<template>
  <v-container
    class="py-8 px-6"
    fluid
  >
    <PageTitle
      icon="mdi-pencil-box-outline"
      main="Compras e licitações"
      sub="contratos"
      home='/compras'
    />
    <div>
      <Contrato />
    </div>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Contrato from '../contratos/index.vue'
export default {
  name: 'Contratos',
  components: { PageTitle, Contrato },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
